export default class AppConfig {
    constructor() {
        this.config = {
            modozat: 0,
            inputType: null,
            theme: null,
            props: {},
            pages: [],
            hibajelentes: true,
            loadingWindow: true,
            tabbedPages: false,
            sidebarNav: true,
            notifications: true,
            tarifaAdatok: true,
            tabs: true,
            clientValidation: false,
            sideBarNavItems: [],
            help: {
                help: {
                    title: 'Súgó címe',
                    message: 'Súgó szövege',
                },
                codename: '',
                aktiv: false,
            },
        };
    }

    setWindowOptions({ hibajelentes, loadingWindow, notifications, tarifaAdatok, sidebarNav, tabs }) {
        if (typeof hibajelentes === 'boolean') this.config.hibajelentes = hibajelentes;
        if (typeof notifications === 'boolean') this.config.notifications = notifications;
        if (typeof loadingWindow === 'boolean') this.config.loadingWindow = loadingWindow;
        if (typeof tarifaAdatok === 'boolean') this.config.tarifaAdatok = tarifaAdatok;
        if (typeof sidebarNav === 'boolean') this.config.sideBarNav = sidebarNav;
        if (typeof tabs === 'boolean') this.config.tabs = tabs;
    }

    setOnline(isOnline) {
        this.config.online = isOnline;
    }

    setPages(pages) {
        if (pages.length > 0) {
            this.config.tabbedPages = true;
        }
        this.config.pages = pages;
    }

    setSideBarNavItems(items) {
        this.config.sideBarNavItems = items;
    }

    setHelp({
        title, message, codename, aktiv,
    }) {
        this.config.help.help.title = title;
        this.config.help.help.message = message;
        this.config.help.codename = codename;
        this.config.help.aktiv = aktiv;
    }

    setTheme(theme, props) {
        this.config.theme = theme;
        this.config.props = { ...this.config.props, ...props };
    }

    setModozat(modozat) {
        this.config.modozat = modozat;
    }

    getConfig() {
        return this.config;
    }

    setClientValidation(validate) {
        this.config.clientValidation = validate;
    }
}
